import dayjs from '../libs/dayjs';

export const getTimezoneOffsetString = (tz: string) => {
    const now = dayjs().tz(tz);

    const offset = now.utcOffset();
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;

    const offsetSign = offset >= 0 ? '+' : '-';

    const offsetString = `GMT ${offsetSign}${offsetHours}:${offsetMinutes.toString().padStart(2, '0')}`;

    return `(${offsetString})`;
};
